import { styled } from '@qwealth/qcore';
import { Box } from '@qwealth/qcore';
import { TASK_OVERDUE, TASK_NOT_STARTED, TASK_IN_PROGRESS, TASK_BLOCKED, TASK_COMPLETED, TASK_DELETED } from '@qwealth/qdata';
import { ExtendedTaskStatus } from 'data/models/Activity';

const Wrapper = styled.div`
  max-width: 500px;
  max-height: 500px;
  font-size: 14px;
`;

export const SignificantChangeToolTip = (
  <Wrapper>
    A Significant Change to a client’s information includes changes to their:
    <br />
    <ul>
      <li>risk profile</li>
      <li>investment time horizon</li>
      <li>investment needs and objectives</li>
      <li>as well as any other change that would reasonably be expected to have a significant impact on the net worth or income of the client.</li>
    </ul>
    A significant change to the client’s KYC information may result in the information no longer being sufficient to enable the Portfolio Manager to
    meet their suitability determination obligations. In such circumstances, Portfolio Managers should consider restricting activities in the client’s
    account to liquidating trades, transfers or disbursements.
  </Wrapper>
);

export const MeaningfulInteractionToolTip = (
  <Wrapper>
    A Meaningful Interaction is an interaction between a registered individual and the client where a client’s personal and financial circumstances,
    investment needs, time horizon, and risk profile (KYC information) was discussed and updated.
  </Wrapper>
);

export const RelatedTasksListToolTip = (
  <Wrapper>
    The Related Task dropdown displays the same tasks shown in the Tasks section of the Household, respecting any active filters applied to that view.
    This ensures you can only link notes to active, relevant tasks.
    <br />
    <br />
    Note: Completed tasks are excluded from this dropdown regardless of whether they appear in the Tasks section.
  </Wrapper>
);

export const taskStatusTooltip = (status: ExtendedTaskStatus) => {
  switch (status) {
    case TASK_NOT_STARTED:
      return <Wrapper>Status: Not Started</Wrapper>;
    case TASK_IN_PROGRESS:
      return <Wrapper>Status: In Progress</Wrapper>;
    case TASK_BLOCKED:
      return <Wrapper>Status: Blocked</Wrapper>;
    case TASK_COMPLETED:
      return <Wrapper>Status: Completed</Wrapper>;
    case TASK_OVERDUE:
      return <Wrapper>Status: Overdue</Wrapper>;
    case TASK_DELETED:
      return <Wrapper>Status: Deleted</Wrapper>;
    default:
      return <Wrapper>Status: No Status</Wrapper>;
  }
};

/**
 * @deprecated This is deprecated, and will be moved to the API/DB
 */
const SCORE_TYPES = ['Defensive', 'Defensive Balanced', 'Balanced', 'Balanced Growth', 'Growth'];

/**
 * @deprecated This is deprecated, and will be moved to the API/DB
 */
const ABILITY_SCORE_RANGE = [
  {
    from: 0,
    to: 9,
  },
  {
    from: 10,
    to: 19,
  },
  {
    from: 20,
    to: 29,
  },
  {
    from: 30,
    to: 39,
  },
  {
    from: 40,
    to: 48,
  },
];

/**
 * @deprecated This is deprecated, and will be moved to the API/DB
 */
const WILLINGNESS_SCORE_RANGE = [
  {
    from: 0,
    to: 10,
  },
  {
    from: 11,
    to: 21,
  },
  {
    from: 22,
    to: 32,
  },
  {
    from: 33,
    to: 44,
  },
  {
    from: 45,
    to: 56,
  },
];

export const RTQScoreTooltip = (
  <Wrapper>
    <Box display="flex" borderBottom="1px solid #ffffff">
      <Box width={250} textAlign="center">
        Ability
      </Box>
      <Box width={250} textAlign="center">
        Willingness
      </Box>
    </Box>
    {SCORE_TYPES.map((scoreType, index) => (
      <Box key={scoreType} display="flex" paddingY="small">
        <Box width="50%" display="flex" justifyContent="space-between" paddingRight="large">
          <Box width="60%">{scoreType}</Box>
          <Box>{ABILITY_SCORE_RANGE[index].from}</Box>
          <p>-</p>
          <Box>{ABILITY_SCORE_RANGE[index].to}</Box>
        </Box>
        <Box width="50%" display="flex" justifyContent="space-between" paddingLeft="large">
          <Box width="60%">{scoreType}</Box>
          <Box>{WILLINGNESS_SCORE_RANGE[index].from}</Box>
          <p>-</p>
          <Box>{WILLINGNESS_SCORE_RANGE[index].to}</Box>
        </Box>
      </Box>
    ))}
  </Wrapper>
);
